import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {Card} from 'shells/card/card';
import {colors} from 'shells/colors/colors';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import {Link} from 'shells/link/link';
import {LinkWithCopyButton} from 'shells/link/link-with-copy-button';

import styles from './domain-card.module.css';

type Props = {
    link: string;
    onClickEdit: () => void;
    isCustom?: boolean;
    isVerified?: boolean | null | undefined;
};

export function DomainCard(props: Props) {
    let leftLineColor: string = colors.grey,
        label;

    if (props.isCustom) {
        leftLineColor = props.isVerified ? colors.blueDk : colors.orangeAttention;
        label = (
            <div className={styles.label}>
                {props.isVerified ? (
                    'Custom domain'
                ) : (
                    <>
                        {/* @ts-expect-error */}
                        <WarningIcon size={11} color={colors.orangeAttention} wrapWithDiv={false} />
                        <div>
                            This still needs to be verified in ‘
                            <Link
                                // @ts-expect-error
                                as={RoutedLink}
                                variant='primary'
                                to='/setup/domains'
                                newTab={true}
                            >
                                Domains
                            </Link>
                            ’
                        </div>
                    </>
                )}
            </div>
        );
    }

    return (
        <Card hasBorder={true} hasShadow={true} fitHeight={true} leftLineColor={leftLineColor}>
            <div className={styles['content-container']}>
                <div className={styles['link-container']}>
                    <div className={styles.link}>
                        <LinkWithCopyButton link={props.link} size='small' shouldTruncate={true} />
                    </div>
                    {label}
                </div>
                <ButtonMover size='normal' direction='right'>
                    <Button variant='text-primary' onClick={props.onClickEdit}>
                        Edit
                    </Button>
                </ButtonMover>
            </div>
        </Card>
    );
}
